var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78255 0C4.38856 0 0 4.38856 0 9.78255C0 15.1765 4.38856 19.5651 9.78255 19.5651C12.0267 19.5651 14.0903 18.7974 15.7427 17.5218L22.8525 24.6315C23.3438 25.1228 24.1402 25.1228 24.6315 24.6315C25.1228 24.1402 25.1228 23.3438 24.6315 22.8525L17.5218 15.7427C18.7974 14.0903 19.5651 12.0267 19.5651 9.78255C19.5651 4.38856 15.1765 0 9.78255 0ZM9.78255 2.1739C13.9776 2.1739 17.3912 5.58747 17.3912 9.78255C17.3912 13.9776 13.9776 17.3912 9.78255 17.3912C5.58747 17.3912 2.1739 13.9776 2.1739 9.78255C2.1739 5.58747 5.58747 2.1739 9.78255 2.1739Z",
    fill: "white",
    fillOpacity: 0.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearch);
export default __webpack_public_path__ + "static/media/menu-search.114b106c4196e98f6b6fee3d7f5493d4.svg";
export { ForwardRef as ReactComponent };